import { css } from '@emotion/css';
import { rgba } from 'polished';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      boxSizing: 'border-box',
    },
    borderRadius: '0.25rem',
    padding: '0.125rem 0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    position: 'relative',
    '&--large': { maxWidth: '9.5rem', width: '100%' },
    '&--medium': { maxWidth: '8rem', width: '100%' },
    '&--small': {
      maxWidth: '6.813rem',
      width: '100%',
      padding: '0rem 0.5rem',
    },
    '&--miniature': {
      width: '1rem',
      height: '1rem',
    },
    '&__text': {
      fontWeight: theme.value.typography.fontWeight.semibold,
      fontSize: '1rem',
    },
    '&__text--large': {
      fontSize: '0.75rem',
      lineHeight: '1.125rem',
    },
    '&__text--medium': {
      fontSize: '0.75rem',
      lineHeight: '1.125rem',
    },
    '&__text--small': {
      fontSize: '0.625rem',
      lineHeight: '1rem',
    },
    '&__status-indicator': {
      width: '0.625rem',
      height: '0.625rem',
      position: 'absolute',
      borderRadius: '0.125rem',
    },
    '&--default': {
      color: theme.value.colors.gray.medium1,
      background: theme.value.colors.gray.light3,
    },
    '&--default > &__text': {
      color: theme.value.colors.gray.medium1,
    },
    '&--default > &__status-indicator': {
      background: theme.value.colors.gray.medium1,
    },
    '&--success': {
      color: theme.value.colors.success,
      background: rgba(theme.value.colors.success, 0.1),
    },
    '&--success > &__text': {
      color: theme.value.colors.success,
    },
    '&--success > &__status-indicator': {
      background: theme.value.colors.success,
    },
    '&--in-process': {
      background: rgba(theme.value.colors.inProcess, 0.1),
    },
    '&--in-process > &__text': {
      color: theme.value.colors.inProcessDark,
    },
    '&--in-process > &__status-indicator': {
      background: theme.value.colors.inProcessDark,
    },
    '&--pending': {
      background: rgba(theme.value.colors.info, 0.1),
    },
    '&--pending > &__text': {
      color: theme.value.colors.info,
    },
    '&--pending > &__status-indicator': {
      background: theme.value.colors.info,
    },
    '&--toku': {
      background: rgba(theme.value.colors.primary.light4, 1),
    },
    '&--toku > &__text': {
      color: theme.value.colors.primary.main,
    },
    '&--toku > &__status-indicator': {
      background: theme.value.colors.primary.main,
    },
    '&--error': {
      color: theme.value.colors.error,
      background: rgba(theme.value.colors.error, 0.1),
    },
    '&--error > &__text': {
      color: theme.value.colors.error,
    },
    '&--error > &__status-indicator': {
      background: theme.value.colors.error,
    },
  }));
  return baseClass;
};
